// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "static/js/" + chunkId + "." + "60356bae" + ".js"; };